import { render, staticRenderFns } from "./setAdminModel.vue?vue&type=template&id=346f0ac7&scoped=true&"
import script from "./setAdminModel.vue?vue&type=script&lang=js&"
export * from "./setAdminModel.vue?vue&type=script&lang=js&"
import style0 from "./setAdminModel.vue?vue&type=style&index=0&id=346f0ac7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346f0ac7",
  null
  
)

export default component.exports